import React, { useEffect } from "react";
import "./home.css";
import TriggerActionService from "./TriggerActionService";
import ActionTriggerConstants from "./ActionTriggerConstants";
import DownloadLandingLite from "./DownloadLandingLite";
import Localize from "./Localize/Localize";
import LocalizeKeys from "./Localize/LocalizeKeys";

const Home = () => {
    useEffect(() => {
        TriggerActionService.sendTriggerAction(
            ActionTriggerConstants.HOME_OPEN,
            "",
            {
                sourceUrl: "Home",
                pageType: "DownloadLanding",
            }
        ).catch(() => {});

        document.body.classList.add("home-body");

        return () => {
            document.body.classList.remove("home-body");
        };
    }, []);

    return (
        <main className="home-container">
            <section className="home-shell">
                <div className="home-top">
                    <header className="home-header">
                        <a
                            href="https://mundijuegoscash.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="home-logo-link"
                        >
                            <img
                                className="home-logo"
                                src="https://frontend.assets.tangelogames.app/skills/landing/icons/M_cash_app_logo.png"
                                alt="Mundijuegos Cash"
                            />
                        </a>
                    </header>

                    <section className="home-hero">
                        <div className="home-copy">
                            <h1 className="home-title">
                                {Localize.translateAndFormat(LocalizeKeys.HOME_HERO_TITLE)}
                            </h1>

                            <p className="home-subtitle">
                                {Localize.translate(LocalizeKeys.HOME_HERO_SUBTITLE)}
                            </p>
                        </div>
                    </section>
                </div>

                <div className="home-middle">
                    <section className="home-product-shot">
                        <div className="home-product-glow"/>
                        <img
                            src="https://frontend.assets.tangelogames.app/skills/landing/icons/middle_device.png"
                            alt="Game UI"
                        />
                    </section>
                </div>

                <div className="home-bottom">
                    <section className="home-cta-section">
                        <p className="home-download-title">
                            {Localize.translate(LocalizeKeys.HOME_DOWNLOAD_TITLE)}
                        </p>

                        <div className="home-download-card">
                            <DownloadLandingLite />
                        </div>
                    </section>
                </div>
            </section>
        </main>
    );
};

export default Home;